// App router — Phase 1 + Phase 2A.
// Wizard steps 2..10 mounted behind <PlannerRoute> guards.

import React from 'react';
import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom';

import Welcome from './pages/Welcome';
import SignIn from './pages/SignIn';
import AccountDetails from './pages/AccountDetails';
import AdminDashboard from './pages/AdminDashboard';
import ComingSoon from './pages/ComingSoon';
import TrainerApply from './pages/trainer/TrainerApply';
import TrainerDashboard from './pages/trainer/TrainerDashboard';
import AdminTrainers from './pages/admin/AdminTrainers';

import Step2Days from './pages/planner/Step2Days';
import Step3Goal from './pages/planner/Step3Goal';
import Step4Body from './pages/planner/Step4Body';
import Step5Calories from './pages/planner/Step5Calories';
import Step6Macros from './pages/planner/Step6Macros';
import Step7Allergies from './pages/planner/Step7Allergies';
import Step8Restrictions from './pages/planner/Step8Restrictions';
import Step9Preferences from './pages/planner/Step9Preferences';
import Step10Generating from './pages/planner/Step10Generating';
import MealResults from './pages/MealResults';
import ReviewOrder from './pages/ReviewOrder';
import OrderStatus from './pages/OrderStatus';
import MealBrowser from './pages/planner/MealBrowser';

import PlannerRoute from './components/planner/PlannerRoute';
import { ProfileGate } from './components/ProfileGate';
import { PlannerDraftSync } from './lib/plannerDraftSync';

function App() {
  return (
    <div className="App">
      <BrowserRouter>
        <PlannerDraftSync />
        <Routes>
          <Route path="/" element={<Welcome />} />

          <Route path="/plan/days"        element={<PlannerRoute step={1}><Step2Days /></PlannerRoute>} />
          <Route path="/plan/goal"        element={<PlannerRoute step={2}><Step3Goal /></PlannerRoute>} />
          <Route path="/plan/body"        element={<PlannerRoute step={3}><Step4Body /></PlannerRoute>} />
          <Route path="/plan/calories"    element={<PlannerRoute step={4}><Step5Calories /></PlannerRoute>} />
          <Route path="/plan/macros"      element={<PlannerRoute step={5}><Step6Macros /></PlannerRoute>} />
          <Route path="/plan/allergies"   element={<PlannerRoute step={6}><Step7Allergies /></PlannerRoute>} />
          <Route path="/plan/restrictions" element={<PlannerRoute step={7}><Step8Restrictions /></PlannerRoute>} />
          <Route path="/plan/preferences" element={<PlannerRoute step={8}><Step9Preferences /></PlannerRoute>} />
          <Route path="/plan/generate"    element={<PlannerRoute step={9}><Step10Generating /></PlannerRoute>} />

          {/* Placeholder for Phase 2B */}
          <Route path="/plan/results"     element={<MealResults />} />
          <Route path="/plan/review"      element={<ProfileGate><ReviewOrder /></ProfileGate>} />
          <Route path="/plan/order"       element={<ProfileGate><OrderStatus /></ProfileGate>} />

          {/* Meal catalog + selection (authenticated) */}
          <Route path="/plan/meals"       element={<ProfileGate><MealBrowser /></ProfileGate>} />

          {/* Auth + admin (Phase 3+) */}
          <Route path="/sign-in" element={<SignIn />} />
          <Route path="/account/details" element={<AccountDetails />} />
          <Route path="/admin" element={<AdminDashboard />} />

          {/* Trainer program (Phase 1 frontend) */}
          <Route path="/trainer/apply" element={<TrainerApply />} />
          <Route path="/trainer/dashboard" element={<TrainerDashboard />} />
          <Route path="/admin/trainers" element={<AdminTrainers />} />

          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </BrowserRouter>
    </div>
  );
}

export default App;
